import * as yup from 'yup';
import { RendererType } from '../../../data-models/field-definition';
import { schemaToFormFields } from '../../../util/schema-utils';

/**
 * Sector config page schema. A sector is just a named, sortable item, so the
 * config form is a single required "Name" text field.
 */
export function sectorConfigFormSchema() {
  return yup.object({
    name: yup
      .string()
      .required()
      .label('Name')
      .formMeta({
        renderer: RendererType.text,
        rendererMeta: { maxLength: -1 },
      }),
  });
}

export function getSectorFields() {
  return schemaToFormFields(sectorConfigFormSchema(), ['name']);
}
